import React, { useEffect } from "react";
import MovingText from "react-moving-text";
import "./Projects.css";
import Project from "./Project";
import ReversedProject from "./ReversedProject";
import Aos from "aos";
import "aos/dist/aos.css";
import Transition from "../Transition/Transition";

const Projects = () => {
  useEffect(() => {
    Aos.init();
  }, []);
  return (
    <div className="projects-section">
      <Transition />
      <h1>
        <MovingText
          type="fadeInFromBottom"
          duration="2000ms"
          delay="0s"
          direction="normal"
          timing="ease"
          iteration="1"
          fillMode="none"
        >
          From idea to Reality
        </MovingText>
      </h1>
      <div
        data-aos="fade-up"
        data-aos-anchor-placement="center-bottom"
        data-aos-duration="2000"
      >
        <Project
          image={"netflix.png"}
          projectName={"Netflix Clone"}
          aboutProject={
            "Netflix clone project is built using React and the Movie Database API. The project aims to replicate the user experience of the popular streaming platform Netflix. When a user first visits the application, they are presented with a login page. Once the user enters their login credentials, they are granted access to the movie and TV show library. Additionally, a banner movie changes each time the page refreshed."
          }
          liveLink={"https://imans-netflix.netlify.app/"}
          githubLink={"https://github.com/Imann7/react-netflix-clone"}
        />
      </div>
      <div
        data-aos="fade-up"
        data-aos-anchor-placement="center-bottom"
        data-aos-duration="1500"
      >
        <ReversedProject
          image={"sneakers.png"}
          projectName={"Sneakers Store"}
          aboutProject={
            "The project focuses on building a ReactJS application using hooks, React Router, Axios, SCSS, React Context and Macro-css  library(something like tailwind) to simulate a mock sneaker e- commerce website. Which provides a user-friendly and efficient way for users to browse and purchase their favorite sneakers online."
          }
          liveLink={"https://imans-sneakers-hub.vercel.app/"}
          githubLink={"https://github.com/Imann7/React-Sneakers-Store"}
        />
      </div>
      <div
        data-aos="fade-up"
        data-aos-anchor-placement="center-bottom"
        data-aos-duration="1500"
      >
        <Project
          image={"weather.png"}
          projectName={"Weather App"}
          aboutProject={
            "The React Weather App is a web application that allows you to check the current weather conditions in any city around the world. It is built using React.js and the OpenWeather API. "
          }
          liveLink={"https://imans-weather-app.vercel.app/"}
          githubLink={"https://github.com/Imann7/React-Weather-App"}
        />
      </div>
      <div
        data-aos="fade-up"
        data-aos-anchor-placement="center-bottom"
        data-aos-duration="1500"
      >
        <ReversedProject
          image={"tesla.png"}
          projectName={"Tesla Clone"}
          aboutProject={
            "Tesla Clone project, a visually stunning web application built using HTML and CSS that replicates the iconic design and user experience of the Tesla official website. This project showcases my expertise in front-end web development and my ability to create visually stunning and highly interactive user interfaces."
          }
          liveLink={"https://tesla-websitee-clone.netlify.app/"}
          githubLink={"https://github.com/Imann7/Tesla-Clone"}
        />
      </div>
      <div
        data-aos="fade-up"
        data-aos-anchor-placement="center-bottom"
        data-aos-duration="1500"
      >
        <Project
          image={"ecom.png"}
          projectName={"E-commerence Store"}
          aboutProject={
            "An e-commerce website built with HTML, CSS, and JavaScript is a platform that allows users to browse and purchase products online. Some common features of an e- commerce website might include a homepage with a product catalog, product detail pages with information and images. "
          }
          liveLink={"https://ecom-website-clone.netlify.app/"}
          githubLink={"https://github.com/Imann7/E-commerce"}
        />
      </div>
      <div
        data-aos="fade-up"
        data-aos-anchor-placement="center-bottom"
        data-aos-duration="1500"
      >
        <ReversedProject
          image={"gamee.png"}
          projectName={"Roll Dice Game"}
          aboutProject={
            "A fun and interactive 2-player game built mainly with JavaScript. In this game, players take turns rolling dice to accumulate points. Players can choose to hold their points at any time to prevent losing them, but if they roll a 1, they lose all their accumulated points for that turn. The first player to reach 100 points wins the game. With its simple yet engaging gameplay, the Roll Dice Game is a great way to spend time with friends."
          }
          liveLink={"https://roll-dice-gamejs.netlify.app/"}
          githubLink={"https://github.com/Imann7/Pig-Game"}
        />
      </div>
      <div
        data-aos="fade-up"
        data-aos-anchor-placement="center-bottom"
        data-aos-duration="1500"
      >
        <Project
          image={"tripwise.png"}
          projectName={"TripWise"}
          aboutProject={
            "Tripwise is a web application built with React that uses the Travel Advisor API from RapidAPI and the Google Maps and Places APIs from Google Cloud Platform to help users find the best restaurants, hotels, and attractions around them, or in any other location they choose. "
          }
          liveLink={"https://trip-wise.vercel.app/"}
          githubLink={"https://github.com/Imann7/TripWise"}
        />
      </div>
    </div>
  );
};

export default Projects;
